import React from 'react';
import "./styles.css";
import { Grid, Box, Typography } from "@mui/material";

const Footer = () => {
   // return (
        // <Box className="main-footer" sx={{ padding: '10px 0', backgroundColor: '#f8f9fa' }}>
        //     <Grid container spacing={1} justifyContent="center" sx={{ textAlign: 'center' }}>
        //         <Grid item xs={12}>
        //             <Typography variant="h6" sx={{ fontFamily: 'Rubik', fontSize: '16px', color: '#333' }}>
        //                 Digi Aqua
        //             </Typography>
        //         </Grid>
                
        //         <Grid item xs={12}>
        //             <Typography variant="body2" sx={{ fontFamily: 'Rubik', fontSize: '12px', color: '#777' }}>
        //                 © 2024 Digi Aqua. All rights reserved.
        //             </Typography>
        //         </Grid>
        //     </Grid>
        // </Box>
    // );
}

export default Footer;
